<template>
  <v-card class="block-card" :class="{ 'block-card--full': !block.enabled }">
    <v-card-text class="pa-4">
      <div class="d-flex align-center mb-3">
        <v-switch
          v-model="block.enabled"
          label="Активен"
          dense
          class="mr-3"
          @change="$emit('change')"
        />

        <span v-if="!block.enabled" class="text-grey mt-1 ml-6">
          Блок не активен
        </span>
        <small v-if="block.id" class="text-caption grey--text mt-1 ml-3">
          ID: {{ block.id }}
        </small>
        <small v-else class="text-caption grey--text mt-1 ml-3">
          Новый блок (несохраненный)
        </small>
        <v-spacer></v-spacer>
        <v-btn
          small
          icon
          color="error"
          @click="$emit('remove')"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </div>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="block.title"
            label="Заголовок"
            dense
            outlined
            prepend-icon="mdi-format-title"
            @input="$emit('change')"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="block.date"
            label="Дата (опционально)"
            dense
            clearable
            outlined
            prepend-icon="mdi-calendar"
            hint="Например: 15.12.2024"
            @input="$emit('change')"
          />
        </v-col>
        <template v-if="block.enabled">
          <v-col cols="12">
            <v-textarea
              v-model="block.description"
              label="Краткое описание"
              rows="3"
              dense
              outlined
              prepend-icon="mdi-text"
              hint="Краткое описание для отображения в карточке"
              @input="$emit('change')"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="block.phone"
              label="Номер телефона"
              dense
              outlined
              prepend-icon="mdi-phone"
              hint="Например: +7 (999) 123-45-67 или 22-55-33"
              maxlength="16"
              @input="$emit('change')"
            />
          </v-col>

          <v-col cols="12" md="6">
            <IconSelector
              v-model="block.icon"
              @input="$emit('change')"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              v-model="block.color"
              :items="colorOptions"
              label="Цветовая схема"
              dense
              outlined
              prepend-icon="mdi-palette-outline"
              @change="$emit('change')"
            />
          </v-col>

          <!--        <v-col cols="12" md="6">-->
          <!--          <v-file-input-->
          <!--            :value="block.imageFile"-->
          <!--            label="Изображение"-->
          <!--            dense-->
          <!--            outlined-->
          <!--            prepend-icon="mdi-image"-->
          <!--            accept="image/*"-->
          <!--            hint="Небольшое изображение для новости"-->
          <!--            @change="handleImageChange"-->
          <!--            clearable-->
          <!--          ></v-file-input>-->
          <!--          <div v-if="block.image" class="mt-2">-->
          <!--            <v-chip small color="success" class="mr-2">-->
          <!--              <v-icon small class="mr-1">mdi-check</v-icon>-->
          <!--              Изображение загружено-->
          <!--            </v-chip>-->
          <!--            <v-btn-->
          <!--              small-->
          <!--              text-->
          <!--              color="error"-->
          <!--              @click="removeImage"-->
          <!--            >-->
          <!--              <v-icon small>mdi-delete</v-icon>-->
          <!--              Удалить-->
          <!--            </v-btn>-->
          <!--          </div>-->
          <!--        </v-col>-->

          <v-col cols="12" md="6">
            <v-select
              v-model="block.type"
              :items="typeOptions"
              label="Тип блока"
              dense
              outlined
              prepend-icon="mdi-tag"
              @change="$emit('change')"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="block.roles"
              :items="roleOptions"
              label="Доступ по ролям"
              dense
              outlined
              prepend-icon="mdi-account-group"
              multiple
              clearable
              hint="Выберите роли, которым доступен блок"
              persistent-hint
              @change="$emit('change')"
            />
          </v-col>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import IconSelector from '../../IconSelector.vue';

export default {
  name: 'ArticleBlock',
  components: {
    IconSelector,
  },
  props: {
    block: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      colorOptions: [
        { text: 'Синий (по умолчанию)', value: 'primary' },
        { text: 'Зелёный', value: 'success' },
        { text: 'Оранжевый', value: 'warning' },
        { text: 'Красный', value: 'error' },
        { text: 'Фиолетовый', value: 'purple' },
        { text: 'Бирюзовый', value: 'teal' },
      ],
      roleOptions: [
        { text: 'Администратор', value: 'admin' },
        { text: 'Админ-инженер', value: 'admin-engineer' },
        { text: 'Менеджер', value: 'manager' },
        { text: 'Агент', value: 'agent' },
        { text: 'Кол-центр', value: 'call-center' },
        { text: 'Мастер', value: 'master' },
        { text: 'Администратор КПП', value: 'checkpoint-admin' },
      ],
      typeOptions: [
        { text: 'Новость', value: 'news' },
        { text: 'Памятка', value: 'reminder' },
        { text: 'Реклама', value: 'marketing' },
        { text: 'Важное уведомление', value: 'important' },
        { text: 'Информация', value: 'info' },
      ],
    };
  },
  methods: {
    handleImageChange (file) {
      if (Array.isArray(file)) file = file[0];
      if (file) {
        if (file instanceof File) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.block.image = e.target.result;
            this.block.imageFile = file;
            this.$emit('change');
          };
          reader.readAsDataURL(file);
        } else if (typeof file === 'string') {
          this.block.image = file;
          this.block.imageFile = null;
          this.$emit('change');
        } else {
          console.warn('Неподдерживаемый тип файла:', typeof file, file);
        }
      } else {
        this.block.image = '';
        this.block.imageFile = null;
        this.$emit('change');
      }
    },
    removeImage () {
      this.block.image = '';
      this.block.imageFile = null;
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
.block-card {
  transition: all 0.2s ease;
}
.block-card--full {
  width: 100% !important;
}
</style>
